<div class="p-d-flex p-jc-center">
  <div class="placeholder">
    <i class="pi pi-folder-open"></i>
    <div class="wrapper">
      <p>{{ text }}</p>
    </div>
  </div>
</div>
